<template>
  <!-- 添加汇率弹窗 -->
  <mrc_ess_myDialog :title="title"
                    :isopen="isopen"
                    @cancel="cancel"
                    @success="success"
                    :loading="rateDialogSubmitLoading.rateLoading"
                    :width="550"
                    :disabled="true">
    <v-card-text class="pa-0">
      <v-row>
        <!-- <mrc_ess_switch
          :true-value="1"
          v-if="params.uuid"
          :false-value="0"
          v-model="params.is_used"
          :true-text="$t('label_To_enable_the')"
          :false-text="$t('label_disable')"
        ></mrc_ess_switch> -->
        <!-- 原货币 -->
        <v-col class="d-flex"
               cols="12"
               sm="12">
          <mrc_ess_prompt :rules="false"
                          @getSelectItem="originalChange"
                          :disabled="false"
                          :label="$t('label_The_original_money') + '*'"
                          :chips="false"
                          :errMsg="$errors('params', 'original_currency_uuid', requiredRule)"
                          v-model="params.original_currency_uuid"
                          obj="exchange_original">
          </mrc_ess_prompt>
        </v-col>
        <!-- 兑换成 -->
        <v-col class="d-flex"
               cols="12"
               sm="12">
          <mrc_ess_prompt :rules="false"
                          @getSelectItem="foreignChange"
                          :disabled="false"
                          :label="$t('label_Converted_into') + '*'"
                          :errMsg="$errors('params', 'foreign_currency_uuid', requiredRule)"
                          v-model="params.foreign_currency_uuid"
                          :chips="false"
                          :obj="exchange_foreign">
          </mrc_ess_prompt>
        </v-col>
        <!-- 生效时间 -->
        <v-col class="d-flex"
               cols="12"
               sm="12">
          <mrc_ess_datePicker :label="$t('label_The_effective_date') + '*'"
                              :placeholder="$t('label_The_effective_date')"
                              :disabled="false"
                              :errMsg="$errors('params', 'effective_start_date', requiredRule)"
                              v-model="params.effective_start_date"></mrc_ess_datePicker>
        </v-col>
        <!-- 汇率 -->
        <v-col md="12">
          汇率*
          <v-sheet class="d-flex">
            <v-text-field solo
                          flat
                          :readonly="!Boolean(prefix)"
                          background-color="grey lighten-3"
                          :error-messages="
                $errors(
                  'params',
                  'exchange_rate',
                  requiredRule.concat([...noSpaces, ...onlyNum])
                )
              "
                          height="72px"
                          style="width: 40%;text-align: center"
                          v-model="params.exchange_rate"
                          :placeholder="$t('label_inputExchangeRate')"
                          :prefix="prefix"
                          @input="$v.params.exchange_rate.$touch()">
            </v-text-field>

            <span class="mx-5 pt-6">/</span>
            <v-text-field solo
                          readonly
                          :placeholder="$t('label_inputExchangeRate')"
                          flat
                          :value="conversion"
                          background-color="grey lighten-3"
                          height="72px"
                          style="width: 40%"></v-text-field>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </mrc_ess_myDialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  components: {},
  inject: ['rateDialogSubmitLoading'],
  props: {
    isopen: {
      type: Boolean,
      default: false,
    },
    paramsData: {
      type: Object,
      default: () => { },
    },
    title: {
      type: String,
    },
  },
  model: {
    prop: 'isopen',
    event: 'flag',
  },
  data () {
    return {
      // 原货币名称
      originalName: '',
      // 兑换后货币名称
      foreignName: '',
      status: true,
      params: {
        uuid: null,
        original_currency_uuid: '',
        foreign_currency_uuid: '',
        effective_start_date: '',
        // is_used: 1,
        org_level_uuid: this.$store.state.uuid,
        exchange_rate: '',
      },
    }
  },
  validations: {
    params: {
      original_currency_uuid: {
        required,
      },
      foreign_currency_uuid: {
        required,
      },
      effective_start_date: {
        required,
      },
      exchange_rate: {
        required,
        noSpaces (val) {
          return !/^ +| +$/g.test(val)
        },
        onlyNum (val) {
          return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(val)
        },
      },
    },
  },
  created () { },
  mounted () { },
  methods: {
    // 切换原货币
    originalChange (val) {
      // console.log(val, 1)
      this.originalName = val.view_fields
    },
    // 切换兑换货币
    foreignChange (val) {
      // console.log(val, 2)
      this.foreignName = val.view_fields
    },
    success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.$emit('getData', this.params)
      // this.$emit('flag', !this.isopen)
    },
    cancel () {
      this.$emit('flag', !this.isopen)
      this.$emit('cancel')
    },
  },
  computed: {
    prefix () {
      let str = ''
      if (
        this.params.original_currency_uuid &&
        this.params.foreign_currency_uuid
      ) {
        str =
          this.INT(this.params.original_currency_uuid) +
          ' 1 ' +
          '= ' +
          this.INT(this.params.foreign_currency_uuid)
      }
      return str
    },
    conversion () {
      let str = ''
      if (
        this.params.original_currency_uuid &&
        this.params.foreign_currency_uuid &&
        this.params.exchange_rate
      ) {
        str =
          this.INT(this.params.original_currency_uuid) +
          ' ' +
          +(1 / Number(this.params.exchange_rate)).toFixed(5) +
          ' = ' +
          this.INT(this.params.foreign_currency_uuid) +
          ' 1 '
      }
      return str
    },
    exchange_foreign () {
      return {
        prompt_name: 'exchange_foreign',
        original: this.params.original_currency_uuid,
      }
    },
  },
  watch: {
    paramsData: {
      handler (val) {
        if (Object.keys(val).length > 0) {
          this.params.uuid = val.uuid
          // this.params.is_used = val.is_used
          this.params.original_currency_uuid = val.original_currency_uuid
          this.params.foreign_currency_uuid = val.foreign_currency_uuid
          this.params.effective_start_date = val.effective_start_date
          this.params.exchange_rate = val.exchange_rate
        }
      },
      deep: true,
    },
    isopen (val) {
      if (!val) {
        // this.params.is_used = 1
        this.params.uuid = ''
        this.params.original_currency_uuid = ''
        this.params.foreign_currency_uuid = ''
        this.params.effective_start_date = ''
        this.params.exchange_rate = ''
        this.params.org_level_uuid = this.$store.state.uuid
      }
      this.$v.params.$reset()
    },
  },
}
</script>

<style scoped></style>
